import { lowerCase } from 'lodash';

export const getParameterByName = (name: string) => {
  const match = RegExp(`[?&]${name}=([^&]*)`).exec(window.location.search);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
};

export const parseOption = (option: string) => {
  if (option === '%') {
    return 'percentage';
  }

  if (option === '£') {
    return 'pound';
  }

  return lowerCase(option).split(' ').join('-');
};

export const renderDataTest = (tag: string, option?: string) => (getParameterByName('testTags') === 'true') && !!tag && {
  'data-test': option ? `${tag}-${parseOption(option)}` : tag,
};

export interface DataTest {
  dataTest?: false | '' | { 'data-test': string; } | null;
}

export { renderDataTest as default };



// WEBPACK FOOTER //
// ./src/utilities/testAutomation.ts